<div [class.highlight]="view.highlight">
  <classic-checkbox *ngIf="type == 'classic'" [view]="view" [viewValue]="view.value" ></classic-checkbox>
  <standard-checkbox *ngIf="type == 'standard'" [view]="view" ></standard-checkbox>
</div>
